<template>
  <div class="system-user-list">
    <div class="page-title bottom-line">
      {{ $t('menu.static_qr') }}
    </div>
    <div class="filter-container">
      <el-button type="primary" size="small" icon="el-icon-plus" @click="showAddModal">{{ $t('components.create') }}</el-button>
    </div>
    <div class="tableContainer">
      <el-table
        v-loading="listLoading"
        :data="tableData"
        stripe
        fit
        highlight-current-row
        style="width: 100%"
      >
        <el-table-column :label="$t('acceptPayments.qr_thumbnail')" align="center">
          <template slot-scope="scope">
            <el-image
              :src="scope.row.qr_code_img_pure_oss_url"
              style="width: 100px; cursor: pointer;"
              @click="showDetailModal(scope.row)"
            />
          </template>
        </el-table-column>

        <el-table-column :label="$t('acceptPayments.static_qr_id')" align="center">
          <template slot-scope="scope">
            <el-link @click="$router.push({ name: 'Transaction_Manage_Payin', query: { qrNo: scope.row.qr_no } })">{{ scope.row.qr_no }}</el-link>
          </template>
        </el-table-column>

        <el-table-column :label="$t('acceptPayments.tag')" align="center">
          <template slot-scope="scope">
            {{ scope.row.tag }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('system.remark')" align="center">
          <template slot-scope="scope">
            <div style="display: grid; grid-template-columns: 1fr 25px; gap: 10px;">
              <span>{{ scope.row.remark }}</span>
              <svg-icon slot="reference" class-name="icon-function" style="width:15px;margin:0;" icon-class="operation-edit" @click="onClickEditRemark(scope.row)" />
            </div>
          </template>
        </el-table-column>

        <el-table-column :label="$t('components.create_time')" align="center">
          <template slot-scope="scope">
            {{ scope.row.create_time }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('components.operation')" align="center">
          <template slot-scope="scope">
            <el-tooltip placement="top">
              <div slot="content">
                <span> {{ $t('acceptPayments.view_transaction_details') }}</span>
              </div>
              <svg-icon class-name="icon-function" icon-class="operation-detail" @click="onClickDetailBtn(scope.row)" />
            </el-tooltip>

            <el-tooltip placement="top">
              <div slot="content">
                <span> {{ $t('components.download') }}</span> <br>
              </div>
              <svg-icon class-name="icon-function operation-download" icon-class="operation-download" @click="onClickDowmloadBtn(scope.row)" />
            </el-tooltip>

            <el-tooltip placement="top">
              <span slot="content">
                {{ $t('payment_links.copy_link') }}
              </span>
              <svg-icon class-name="icon-function mb-10 copy-btn" icon-class="icon-copy" :data-clipboard-text="scope.row.qr_code_img_pure_oss_url" @click="onClickCopyBtn('.copy-btn','Link')" />
            </el-tooltip>
          </template>
        </el-table-column>

      </el-table>

      <div class="pagination-container">
        <paginator v-if="!listLoading" :list-query="listQuery" @paginator-change="confirm" />
      </div>
    </div>

    <el-dialog :title="$t('acceptPayments.qr_code_detail')" class="diglog-card" :close-on-click-modal="false" :visible.sync="dialogVisible" width="500px" @close="initData">
      <div class="header-line" />
      <div class="item-box">
        <div class="label">{{ $t('acceptPayments.qr_link') }}</div>
        <div class="content">
          <span style="display:inline-block;width:300px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ form.qr_code_img_pure_oss_url }}</span>
          <svg-icon style="margin: 0;" class-name="icon-function copy-btn2" icon-class="icon-copy" :data-clipboard-text="form.qr_code_img_pure_oss_url" @click="onClickCopyBtn('.copy-btn2','Link')" />
        </div>
      </div>

      <div class="item-box">
        <div class="label">{{ $t('acceptPayments.tag') }}</div>
        <div class="content">
          <span>{{ form.tag }}</span>
        </div>
      </div>
    
      <div style="display: flex;flex-direction: column;align-items: center;">
        <img :src="form.qr_code_img_pure_oss_url" style="width: 300px;" />
        <el-button style="margin-top: 20px;" type="primary" icon="el-icon-download" @click="onClickDowmloadBtn(form)">{{ $t('acceptPayments.download_qr_code') }}</el-button>
      </div>

    </el-dialog>

    <CreateStaticQrModal ref="createStaticQrModal" @updateTableData="getTableData" />

  </div>
</template>

<script>
import Clipboard from 'clipboard'
import { GetMchOnboardQrList, PostMchOnboardTagQr } from '@/api/accept-payments/accept-payments'
export default {
  name: 'Static_Qr',
  components: {
    Paginator: () => import('@/views/components/Paginator'),
    CreateStaticQrModal: () => import('./components/Modal/CreateStaticQrModal')
  },
  data() {
    return {
      tableData: [],
      listLoading: false,
      dialogVisible: false,
      form: {},
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      }
    }
  },
  created() {
    this.getTableData()
  },
  methods: {
    initData() {
      this.form = {}
    },
    showDetailModal(row) {
      this.dialogVisible = true
      this.form = row
    },
    onClickCopyBtn(selectClass, name) {
      const btnCopy = new Clipboard(selectClass)
      btnCopy.on('success', () => {
        this.$message.success(`Copy ${name} Successfully!`)
        btnCopy.destroy()
      })
      btnCopy.on('error', function(e) {
        btnCopy.destroy()
      })
    },
    onClickDowmloadBtn(row) {
      window.open(row.qr_code_img_oss_url)
    },
    onClickDetailBtn(row) {
      this.$router.push({ name: 'Transaction_Manage_Payin', query: { qrNo: row.qr_no } })
    },
    confirm() {
      const params = {
        page: this.listQuery.page
      }
      this.handleFilter(params)
    },
    handleFilter(params = {}) {
      this.getTableData(params)
    },
    showAddModal() {
      this.$refs.createStaticQrModal.openModal()
    },
    getTableData(params = {}) {
      this.listLoading = true
      GetMchOnboardQrList(params).then(res => {
        this.tableData = res.data.list
        this.listQuery.total = res.data.total
        this.listQuery.page = params.page ? params.page : 1
      }).finally(() => {
        this.listLoading = false
      })
    },
    onClickEditRemark(row) {
      this.$prompt('', this.$t('system.remark'), {
        confirmButtonText: this.$t('components.confirm'),
        cancelButtonText: this.$t('components.cancel'),
        inputValue: row.remark,
        inputPattern: /^.{0,200}$/,
        inputErrorMessage: 'The length of the comment cannot exceed 200 characters'
      }).then(({ value }) => {
        PostMchOnboardTagQr({ qr_no: row.qr_no, remark: value }).then(res => {
          this.$message.success('Update Successfully')
          this.getTableData()
        })
      })
    }
  }
}
</script>

<style scoped>
  .system-user-list{
    margin: 48px;
    background-color: #fff;
  }
  .filter-container{
    text-align: right;
    padding: 0 24px 24px;
  }
  .search-frame {
    width: 160px;
    margin-left: 5px;
  }
  .search-btn {
    margin-left: 10px;
  }
  .add-btn{
    color: #fff;
  }
  .item-box {
    display: grid;
    grid-template-columns: 100px 1fr;
    margin: 20px 0;
    .label{
      /* width: 100px; */
      font-weight: 500;  font-family: 'Inter-Medium';
      color: #606266;
    }
    .content{
      display: flex;
      align-items: flex-start;
      color: #606266;
    }
  }
</style>
